import React from 'react';
import { Link } from 'react-router-dom';

export default function Refund() {
  return (
    <div style={s.page}>
      <div style={s.container}>

        <div style={s.header}>
          <Link to="/" style={s.back}>← Back to App</Link>
          <h1 style={s.title}>💰 Refund Policy</h1>
          <p style={s.sub}>பணம் திரும்ப கொள்கை | Effective: April 2026</p>
        </div>

        <div style={s.highlight}>
          We offer a <strong>30-day FREE trial</strong> so you can evaluate JSMSTOCK before paying.
          This ensures you are 100% satisfied before any payment.
        </div>

        <h2 style={s.h2}>1. Free Trial (30 Days)</h2>
        <div style={s.greenBox}>
          <strong>✅ 30-Day FREE Trial — No Risk!</strong>
          <ul style={{...s.ul, marginTop:'8px', color:'#1a7a40'}}>
            <li>No payment required during trial</li>
            <li>Full access to all features</li>
            <li>No questions asked if you stop after trial</li>
            <li>Zero financial risk for you!</li>
          </ul>
        </div>

        <h2 style={s.h2}>2. After Trial — Paid Subscription</h2>
        <ul style={s.ul}>
          <li>Subscription: <strong>Rs.299/month</strong></li>
          <li>Payment before or on renewal date</li>
          <li>Account activated within 30 minutes of payment</li>
          <li>Monthly billing — no annual lock-in</li>
        </ul>

        <h2 style={s.h2}>3. Refund Policy</h2>
        <div style={s.warning}>
          <strong>⚠️ JSMSTOCK follows a NO REFUND policy because:</strong>
          <ul style={{...s.ul, marginTop:'8px'}}>
            <li>Software service cannot be "returned" like a physical product</li>
            <li>30-day FREE trial is provided to evaluate before paying</li>
            <li>Once payment is made, you have received the service</li>
            <li>This is standard practice for all SaaS products (Zoho, Tally, etc.)</li>
          </ul>
        </div>

        <h2 style={s.h2}>4. Exceptions — When We Give Refund</h2>
        <div style={s.greenBox}>
          <strong>✅ Refund WILL be given in these cases:</strong>
          <ul style={{...s.ul, marginTop:'8px', color:'#1a7a40'}}>
            <li>Double payment charged due to technical error</li>
            <li>Payment received but account not activated within 24 hours</li>
            <li>Service completely unavailable for more than 7 consecutive days</li>
          </ul>
          <p style={{margin:'8px 0 0', fontSize:'13px', color:'#555'}}>
            For refund: Contact us within 7 days of payment via WhatsApp.
            Processing time: 5-7 working days.
          </p>
        </div>

        <h2 style={s.h2}>5. Cancellation</h2>
        <ul style={s.ul}>
          <li>You can stop using JSMSTOCK at any time</li>
          <li>No cancellation fee</li>
          <li>Simply stop making payments — account suspends automatically</li>
          <li>Data retained for 90 days after last payment</li>
          <li>Can reactivate anytime by making payment again</li>
        </ul>

        <h2 style={s.h2}>6. Dispute Resolution</h2>

        <h3 style={s.h3}>Step 1 — Contact Us Directly (Fastest!)</h3>
        <div style={s.contactBox}>
          <p style={{margin:'4px 0'}}>📱 WhatsApp: +91-9159933276 (6PM–9PM, Mon–Sat)</p>
          <p style={{margin:'4px 0'}}>📧 Email: support@jsmstock.com</p>
          <p style={{margin:'4px 0', color:'#888', fontSize:'13px'}}>
            95% of issues resolved within 24 hours!
          </p>
        </div>

        <h3 style={s.h3}>Step 2 — Consumer Forum</h3>
        <ul style={s.ul}>
          <li>Madurai District Consumer Disputes Redressal Commission</li>
          <li>Under Consumer Protection Act, 2019</li>
          <li>National Helpline: <strong>1800-11-4000</strong> (Toll Free)</li>
          <li>Online: consumerhelpline.gov.in</li>
        </ul>

        <h2 style={s.h2}>7. Contact for Billing Issues</h2>
        <div style={s.contactBox}>
          <p style={{margin:'4px 0', fontWeight:'700'}}>JSMSTOCK Support</p>
          <p style={{margin:'4px 0'}}>📱 WhatsApp: +91-9159933276</p>
          <p style={{margin:'4px 0'}}>📧 Email: support@jsmstock.com</p>
          <p style={{margin:'4px 0'}}>⏰ Support Hours: 6PM–9PM, Monday–Saturday</p>
          <p style={{margin:'4px 0'}}>📍 Madurai, Tamil Nadu, India</p>
        </div>

        <div style={s.legalLinks}>
          <Link to="/terms"   style={s.llink}>Terms of Service</Link>
          <span style={s.sep}>|</span>
          <Link to="/privacy" style={s.llink}>Privacy Policy</Link>
          <span style={s.sep}>|</span>
          <Link to="/refund"  style={s.llink}>Refund Policy</Link>
        </div>
        <p style={s.copy}>© 2026 JSMSTOCK | Madurai, Tamil Nadu | support@jsmstock.com</p>
      </div>
    </div>
  );
}

const s = {
  page:{background:'#f5f6fa',minHeight:'100vh',padding:'20px 16px'},
  container:{maxWidth:'800px',margin:'0 auto',background:'white',borderRadius:'12px',padding:'32px',boxShadow:'0 2px 12px rgba(0,0,0,0.08)'},
  header:{marginBottom:'24px',paddingBottom:'20px',borderBottom:'3px solid #27AE60'},
  back:{color:'#3498DB',textDecoration:'none',fontSize:'14px',fontWeight:'600'},
  title:{color:'#2C3E50',margin:'12px 0 4px',fontSize:'26px',fontWeight:'900'},
  sub:{color:'#888',margin:0,fontSize:'14px'},
  highlight:{background:'#EBF5FB',border:'1px solid #3498DB',borderLeft:'5px solid #3498DB',padding:'14px 16px',borderRadius:'6px',marginBottom:'24px',fontSize:'14px',color:'#1a5276'},
  h2:{color:'#2C3E50',fontSize:'18px',fontWeight:'800',marginTop:'28px',marginBottom:'8px',paddingBottom:'6px',borderBottom:'2px solid #EEE'},
  h3:{color:'#3498DB',fontSize:'15px',fontWeight:'700',marginTop:'16px',marginBottom:'6px'},
  p:{color:'#444',fontSize:'14px',lineHeight:'1.7',marginBottom:'8px'},
  ul:{color:'#444',fontSize:'14px',lineHeight:'2',marginBottom:'8px',paddingLeft:'20px'},
  greenBox:{background:'#E8F8F0',border:'1px solid #27AE60',borderLeft:'5px solid #27AE60',padding:'14px 16px',borderRadius:'6px',fontSize:'14px',marginBottom:'12px'},
  warning:{background:'#FFF5F5',border:'1px solid #E74C3C',borderLeft:'5px solid #E74C3C',padding:'14px 16px',borderRadius:'6px',fontSize:'14px',color:'#C0392B',marginBottom:'12px'},
  contactBox:{background:'#EBF5FB',border:'1px solid #3498DB',borderLeft:'5px solid #3498DB',padding:'14px 16px',borderRadius:'6px',fontSize:'14px',color:'#2C3E50'},
  legalLinks:{display:'flex',justifyContent:'center',gap:'8px',marginTop:'40px',padding:'16px',background:'#F8F9FA',borderRadius:'8px'},
  llink:{color:'#3498DB',textDecoration:'none',fontSize:'13px',fontWeight:'600'},
  sep:{color:'#CCC'},
  copy:{textAlign:'center',color:'#999',fontSize:'12px',marginTop:'12px'},
};
